export const createCourse = async ({ BeURL, departmentId, courseName }) => {
    try {
        const res = await fetch(`${BeURL}/departments/${departmentId}/courses`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ courseName }),
        });

        const data = await res.json();

        if (!res.ok) {
            return { success: false, message: data?.message };
        }

        return data;
    } catch (err) {
        console.log("Error in create course", err);
        return { success: false, message: err.message };
    }
};


export const updateCourse = async (
    BeURL,
    courseId,
    syllabusId,
    query
) => {

    try {

        const response = await fetch(
            `${BeURL}/course/${courseId}/syllabus/${syllabusId}`,
            {
                method: "PUT",
                credentials : 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(query)
            }
        )

        const data = await response.json()

        return data

    } catch (err) {

        console.log("Error in updateCourse API", err)

        return {
            success: false,
            message: "Something went wrong"
        }
    }
}



export const deleteModule = async (
    BeURL,
    courseId,
    syllabusId
) => {
    try {
        const response = await fetch(
            `${BeURL}/course/${courseId}/syllabus/${syllabusId}`,
            {
                method: "DELETE",
                credentials : 'include',
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )

        const data = await response.json()

        return data

    } catch (err) {

        console.log("Error in deleteModule API", err)

        return {
            success: false,
            message: "Something went wrong"
        }
    }
}